export const gamesImagesAssetsUrl: string = 'https://storage.googleapis.com/tikalcasino-prod-static-assets/images/';
